export default "__VITE_ASSET__CnVlwnvg__"